module.exports = __webpack_public_path__ + "img/reload.24be9e1a.svg";